<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="this.$l('form_Package_Batch_Type')||'包装采购执行批次类型'" prop="packageBatchType">
            <dict-select
              size="small"
              clearable
              filterable
              v-model="form.packageBatchType"
              :body="{ dictType: 'packageBatchType' }"
              url="/master/common/dict/biz"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="this.$l('form_label_deliveryDate')||'交货日期'" prop="deliveryDate">
            <el-date-picker
              v-model="form.deliveryDate"
              type="date"
              size="small"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="this.$l('form_label_deliveryQty')||'交货数量'">
            <el-input-number
              v-model="form.deliveryQty"
              clearable
              size="small"
              style="width:100%"
              :min="0"
              :step="1"
              :precision="0"
              controls-position="right"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="this.$l('form_label_deliveryDescription')||'交货说明'" prop="deliveryDescription">
            <el-input
              v-model="form.deliveryDescription"
              type="textarea"
              clearable
              size="small"
              rows="2"
              maxlength="500"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from "@/libs/util.validate"
export default {
  props: {
    purchasePackageBatchCode: String,
    packageDetailCode: String,
    packageCode: String,
    disabled: Boolean,
  },
  data() {
    return {
      form: {},
      rules: {
        packageBatchType: [
          {
            required: true,
            message: this.$l('tips_select_packageBatchType')||"请选择包装采购执行批次类型",
            trigger: "change",
          },
        ],
        deliveryDescription: [
          {
            required: true,
            message: this.$l('tips_input_deliveryDescription')||"请输入交货说明",
            trigger: "blur",
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.purchasePackageBatchCode) return
      this.$api
        .purchasePackageBatchDetailApi({
          purchasePackageBatchCode: this.purchasePackageBatchCode,
        })
        .then((res) => {
          this.form = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      let loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      //根据不同的操作调用不同接口
      let saveApi = {}
      if (this.purchasePackageBatchCode) {
        saveApi = this.$api.purchasePackageBatchModifyApi({
          ...this.form,
          purchasePackageDetailCode: this.packageDetailCode,
          purchasePackageCode: this.packageCode,
        })
      } else {
        saveApi = this.$api.purchasePackageBatchAddApi({
          ...this.form,
          purchasePackageDetailCode: this.packageDetailCode,
          purchasePackageCode: this.packageCode,
        })
      }
      saveApi
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: this.$l("INDEX.tips_save_ok") || res.msg,
            type: "success",
          })
          this.$emit("close")
          this.$emit("reload")
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
  },
}
</script>
